import React from "react";
import { useStores } from "_common/hooks";
import { Link, useNavigate } from "react-router-dom";
import i18next from "i18next";

export default function Rank2() {
  const navigate = useNavigate();
  const {
    authStore: { questions },
  } = useStores();

  return (
    <div className="flex mt-2 p-2 bg-[#1c1c1e] bg-gradient-to-r from-[#5e5c5c]  to-[#3f290900] rounded ">
      <div className="">
        <div className="w-12 h-12 text-center text-[#fff]">
          <img
            className="w-12 h-12"
            src="https://api.demo92.apptestlive.com/assets/images/rank_2.webp"
            alt=""
          />
        </div>
      </div>
      <div className="ml-4 w-full">
        <div className="mb-4 text-[#fff]">+675*********13</div>
        <div className="w-full grid grid-cols-2">
          <div className="w-full flex flex-col text-[14px]">
            <span className="text-[#9ca3af] ">
              {i18next.t("profit_amount")} 7 {i18next.t("day")}
            </span>
            <span className="text-[#55af72] text-[14px]">66%</span>
          </div>
          <div className="w-full flex flex-col text-[14px]">
            <span className="text-[#9ca3af] ">
              {i18next.t("profit2")} 7 {i18next.t("day")}
            </span>
            <span className="text-[#fff] text-[14px]">200,861.78</span>
          </div>
        </div>
      </div>
    </div>
  );
}
